"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginLoader = void 0;
/* eslint-disable complexity */
/* eslint-disable no-console */
// constants
const dynamicLoad_1 = require("../../dynamicLoad");
const mobileConnector_1 = require("../../mobileConnector");
const frameBaseLoaderCommon_1 = require("../frameBaseLoaderCommon");
const loginLoader = async (params) => {
    await (0, mobileConnector_1.initMobileCommunicatorWithoutSession)();
    (0, frameBaseLoaderCommon_1.frameLoaderBaseCommon)(params, dynamicLoad_1.Router, dynamicLoad_1.Routes);
};
exports.loginLoader = loginLoader;
//# sourceMappingURL=index.js.map